import React, { ReactElement, useEffect } from 'react'
import Divider from '../../Divider'
import DetailsOverview from './DetailsOverview'
import { ArtData } from '@/database/art'

const DetailsPanel = ({ artData, tabName }: { artData: ArtData | undefined; tabName: string }): ReactElement => {
    useEffect(() => {
        window.location.hash = `#art-${artData?.art.id + tabName}#details`
    }, [artData])

    return (
        <div className="panel">
            <Divider />
            <DetailsOverview artData={artData} />
        </div>
    )
}

export default DetailsPanel
